'use client';

import Script from 'next/script';

import { TOLD_SDK_LOADED_EVENT } from '@/core/analytics/constants';
import { env } from '@/lib/env';

export const ToldWidget = () => (
  <Script
    id="told-widget"
    src="https://scripts.told.club/sdk/sdk.js"
    strategy="afterInteractive"
    onLoad={() => {
      told('init', env.NEXT_PUBLIC_TOLD_WIDGET_ID);
      window.dispatchEvent(new Event(TOLD_SDK_LOADED_EVENT));
    }}
  />
);
